import {
    SET_PROMO_CODES,
    SET_PROMO_CODES_LOADING,
    SET_PROMO_CODES_ERROR,
    SET_PROMO_TRANSACTIONS,
    SET_PROMO_TRANSACTIONS_LOADING,
    RESET_PROMO_CODES,
} from "../constants";

const initialState = {
    codes: [],
    loading: false,
    error: null,
    transactions: [],
    transactionsLoading: false,
};

const promoCodesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PROMO_CODES:
            return {
                ...state,
                codes: action.payload,
                error: null,
            };

        case SET_PROMO_CODES_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case SET_PROMO_CODES_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        case SET_PROMO_TRANSACTIONS:
            return {
                ...state,
                transactions: action.payload,
            };

        case SET_PROMO_TRANSACTIONS_LOADING:
            return {
                ...state,
                transactionsLoading: action.payload,
            };

        case RESET_PROMO_CODES:
            return initialState;

        default:
            return state;
    }
};

export default promoCodesReducer;
